import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=9f5e405a&scoped=true&"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesModal.vue?vue&type=style&index=0&id=9f5e405a&scoped=true&lang=scss&"
import style1 from "./UnsavedChangesModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5e405a",
  null
  
)

export default component.exports